<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">LED屏详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%;"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="LED编号" prop="NUM_EQT">
                <el-input v-model="data.NUM_EQT" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="LED名称" prop="NAME_EQT">
                <el-input
                  v-model="data.NAME_EQT"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="IP地址" prop="IPAdd_EQT">
                <el-input
                  v-model="data.IPAdd_EQT"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区域" prop="ARENUM_EQT">
                <el-select
                  v-model="data.ARENUM_EQT"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in EqRegionArr"
                    :key="item.RegionId"
                    :label="item.RegionName"
                    :value="item.RegionNo"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input
                  v-model="data.Longitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input
                  v-model="data.Latitude"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="屏类型" prop="LedType">
                <el-select
                  v-model="data.LedType"
                  placeholder="请选择"
                  style="width: 100%;"
                  @change="changeType"
                  :disabled="!IsEdit"
                >
                  <el-option
                    v-for="item in LEDTypeArr"
                    :key="item.ItemKey"
                    :label="item.Description"
                    :value="item.ItemValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="色彩" prop="COLOR_TPLEQT">
                <el-select
                  v-model="data.COLOR_TPLEQT"
                  placeholder="请选择"
                  style="width: 100%;"
                  :disabled="!IsEdit || !colorIsEdit"
                >
                  <el-option
                    v-for="item in ColorArr"
                    :key="item.ItemKey"
                    :label="item.Description"
                    :value="item.Extend1"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="长度" prop="LEN_TPLEQT">
                <el-input
                  v-model="data.LEN_TPLEQT"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宽度" prop="WIDTH_TPLEQT">
                <el-input
                  v-model="data.WIDTH_TPLEQT"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="DESCRIBE_EQT">
                <el-input
                  v-model="data.DESCRIBE_EQT"
                  :disabled="!IsEdit"
                  type="textarea"
                  autosize
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "LedDeviceManagerEdit",
  controller: "UI",
  action: "LedDeviceManagerEdit",
  data() {
    return {
      data: {
        LedType: "",
        COLOR_TPLEQT: "",
        Latitude: "",
        Longitude: "",
        ARENUM_EQT: "",
      },
      LEDTypeArr: [],
      ColorArr: [],
      EqRegionArr: [],
      IsEdit: false,
      colorIsEdit: true,
      rules: {
        NUM_EQT: [
          { required: true, message: "请输入LED编号", trigger: "blur" },
        ],
        NAME_EQT: [
          { required: true, message: "请输入LED名称", trigger: "blur" },
        ],
        IPAdd_EQT: [
          { required: true, message: "请输入IP地址", trigger: "blur" },
        ],
        Longitude: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        Latitude: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/,
          },
        ],
        ARENUM_EQT: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        LedType: [
          { required: true, message: "请选择屏类型", trigger: "change" },
        ],
        COLOR_TPLEQT: [
          { required: true, message: "请选择色彩", trigger: "change" },
        ],
        LEN_TPLEQT: [
          {
            required: true,
            message: "请输入有效的长度",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
        WIDTH_TPLEQT: [
          {
            required: true,
            message: "请输入有效的宽度",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
      },
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    //LED类型
    this.getLEDType();
    //LED色彩
    this.getLEDColors();
    //区域
    this.getRegionInfo();
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    getLEDColors() {
      this.config
        .getUValue("LEDSubSystem:Colors", "")
        .then((d) => {
          this.ColorArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getLEDType() {
      this.config
        .getUValue("LEDSubSystem:LEDType", "")
        .then((d) => {
          this.LEDTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //根据 LED 屏类型获取可选的色彩列表。
    changeType(val) {
      //  1. 同步屏只能是全彩屏
      //  2. 异步屏不可能是全彩屏
      if (val == 1) {
        this.data.COLOR_TPLEQT = "全彩";
        this.colorIsEdit = false;
      } else {
        this.data.COLOR_TPLEQT = "";
        this.colorIsEdit = true;
        this.ColorArr = this.ColorArr.slice(0, 3);
      }
    },
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        new MyApis.TranResourcesApi()
          .GetLedEquipmentById(InfoId)
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateLedEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "LED屏信息修改";
            this.logInfo.LogMessage = "LED屏信息修改";
            this.logInfo.ModuleName = "LED系统";
            this.logInfo.PageName = "LED屏信息详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddLedEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "LED屏信息添加";
            this.logInfo.LogMessage = "LED屏信息添加";
            this.logInfo.ModuleName = "LED系统";
            this.logInfo.PageName = "LED屏信息详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
